<template>
  <vx-card class="mt-base mb-5" :title="activityTitle">
    <p class="mb-5">Some Common Skills Used by Police are:</p>
    <ul class="default-list">
      <li>Observation skills</li>
      <li>Gathering and triaging information</li>
      <li>Recording information</li>
      <li>A high level of communication. Both verbal and written forms.</li>
      <li>Conflict resolution</li>
      <li>Decision making skills</li>
      <li>Sense of urgency</li>
    </ul>

    <p class="mb-5">
      Let’s take a look at your observation skills. Watch the video below, then comment on your
      experience.
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <custom-video
          aria-label="Watch observation skills video"
          elem-id="video-btn-0"
          :video-image="videoTrigger1"
          :video-url="videos[1]"
        />
      </div>
    </div>
    <div class="focusable-parent">
      <label
        >Comments:
        <textarea-block
          v-model="data.question1"
          :editable="isEditable"
          class="focus-visible-style"
        />
      </label>
    </div>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import CustomVideo from '@/components/CustomVideo.vue';
export default {
  components: { CustomVideo },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/policing/monkey_business_illusion.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/IGQmdoK_ZfY',
      },
      login_type: localStorage.getItem('login_type'),
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
